import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useArchiveOrder } from "Order/Api/Mutation/archiveOrderMutation";
import { isArchiveOrderConfirmationModalOpenAtom } from "Order/Modules/Examination/Atom/archiveOrderConfirmationModalAtom";
import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import { useAtom } from "jotai";

type OrderArchiveConfirmationModalProps = {
	orderId: number;
};

const orderArchiveResource = Resources.base.order.archive;

export function OrderArchiveConfirmationModal({
	orderId,
}: OrderArchiveConfirmationModalProps) {
	const { t } = useResource();
	const { mutate: archiveOrder, isPending } = useArchiveOrder();
	const [isModalOpen, setIsModalOpen] = useAtom(
		isArchiveOrderConfirmationModalOpenAtom,
	);

	const handleArchiveOrder = () => {
		orderId && archiveOrder(Number(orderId));
		setIsModalOpen(false);
	};

	return (
		<Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)}>
			<DialogTitle>{t(orderArchiveResource.title)}</DialogTitle>
			<DialogContent>{t(orderArchiveResource.description)}</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={() => setIsModalOpen(false)}>
					{t(orderArchiveResource.cancel)}
				</Button>
				<Button
					variant="contained"
					onClick={handleArchiveOrder}
					loading={isPending}
				>
					{t(orderArchiveResource.confirm)}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
